const OfferSpendByOfferScopeDetailsTableLangKey = [
	'column_id',
	'column_date',
	'column_amount',
	'column_account',
	'column_kt_group',
	'column_offer',
	'column_notes'
] as const

type IOfferSpendByOfferScopeDetailsTableLangKey = typeof OfferSpendByOfferScopeDetailsTableLangKey[number]

export type IOfferSpendByOfferScopeDetailsTableLang = {
	offer_spend_by_offer_scope_details_table: Record<IOfferSpendByOfferScopeDetailsTableLangKey, string>
}

const langEntries = OfferSpendByOfferScopeDetailsTableLangKey.map(
	(key: IOfferSpendByOfferScopeDetailsTableLangKey) => [key, `offer_spend_by_offer_scope_details_table.${key}`]
)

const langObj: Record<IOfferSpendByOfferScopeDetailsTableLangKey, string> = Object.fromEntries(langEntries)

export const OFFER_SPEND_BY_OFFER_SCOPE_DETAILS_TABLE_LANG_KEY: IOfferSpendByOfferScopeDetailsTableLang = {
	offer_spend_by_offer_scope_details_table: langObj
}
